import '../assets/css/main.css';
import mainimage from '../assets/img/hero-bg.png';
import NavBar from "../components/navbar";
import Footer from "../components/footer";

function Home() {

  return (
    <>
      <NavBar />
      <main className="main">
        <section id="hero" className="hero section">
          <img src={mainimage} alt="" data-aos="fade-in" />
          <div className="container text-center" data-aos="zoom-out" data-aos-delay="100">
            <div className="row justify-content-center">
              <div className="col-lg-8 hero-intro-content">
                <h2>
                  <span className="signature">
                    Bravaldi
                    <span className="signature-tm">™<span />
                    </span>
                  </span>
                </h2>
                <p>Baroque Composer in a Modern World</p>
                <a href="/about" className="btn-get-started">
                  About Me
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      {/* Scroll Top */}
      <a
          href="#hero"
          id="scroll-top"
          className="scroll-top d-flex align-items-center justify-content-center">
        <i className="bi bi-arrow-up-short" />
      </a>
    </>
  );
}

export default Home;